

import React from 'react';

const CounterArea = () => {
  return (
    <>

<div className="space-bottom">
    <div className="container">
      <div className="counter-wrap">
        <div className="counter-card">
          <div className="media-body">
            <h2 className="box-number text-theme">
              <span className="counter-number">500</span>
              <span className="fw-light">+</span>
            </h2>
            <p className="box-text">Successful Campaigns</p>
          </div>
        </div>
        <div className="divider" />
        <div className="counter-card">
          <div className="media-body">
            <h2 className="box-number text-theme2">
              <span className="counter-number">100</span>
              <span className="fw-light">+</span>
            </h2>
            <p className="box-text">Monthly Donors</p>
          </div>
        </div>
        <div className="divider" />
        <div className="counter-card">
          <div className="media-body">
            <h2 className="box-number text-theme">
              <span className="counter-number">1</span>k
              <span className="fw-light">+</span>
            </h2>
            <p className="box-text">Team Support</p>
          </div>
        </div>
        <div className="divider" />
        <div className="counter-card">
          <div className="media-body">
            <h2 className="box-number text-theme2">
              <span className="counter-number">100</span>
              <span className="fw-light">+</span>
            </h2>
            <p className="box-text">Incredibale</p>
          </div>
        </div>
        <div className="divider" />
      </div>
    </div>
  </div>
 
    </>
  );
};

export default CounterArea;









